<template>
    <div class="app_container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="网络脱产数据" name="first">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无脱产数据信息</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="数据导入" name="second">
                <img src="../../../assets/image/jiaxing/17.png" alt />
            </el-tab-pane>
            <el-tab-pane label="培训补录" name="third">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无培训补录信息</div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        activeName: 'first'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<style scoped>
    .empty {
        display: flex;
        flex-direction: column;
        padding-top: 100px;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .empty-image {
        width: 240px;
        height: 240px;
        margin-bottom: 20px;
    }
    .empty-text {
        color: #999999;
        font-size: 16px;
    }

</style>
